<template>
    <span>
      <b-button class="ml-1 float-right float-right"
                v-if="$route.params.process_type==='ENMALLADO'"
                @click.prevent="(e) => {e.target.blur();squareUpProcess($route.params.id, 'BRECHA OPERACIONAL')}"
                :disabled="difference(totalOutNet,totalInNet)>=0">
        <i class="fa fa-plus"/> BRECHA OP
      </b-button>
      <b-button class="ml-1 float-right"
                v-if="$route.params.process_type==='ENMALLADO'"
                @click.prevent="(e) => {e.target.blur();$bvModal.show('modal-comercial')}"
                :disabled="difference(totalOutNet,totalInNet)>=0||checkBrechaComercial">
        <i class="fa fa-plus"/> BRECHA COM
      </b-button>

      <b-button class="ml-1 float-right"
                @click.prevent="(e) => {e.target.blur();modal_title='MERMA';$bvModal.show('modal-merma')}"
                :disabled="difference(totalOutNet,totalInNet)>=0">
        <i class="fa fa-plus"/> MERMA
      </b-button>
      <span class="btn btn-outline-dark mr-1">Rendimiento: {{percentage(totalSaleable,totalInNet)}}%</span>
      <!--      <span class="btn btn-outline-dark mr-1">Merma: {{percentage(totalWaste,totalInNet)}}%</span>-->
      <span class="btn btn-outline-dark mr-1">Diferencia: {{differenceNet}}</span>
      <span class="btn btn-outline-dark mr-1">Lote en proceso: {{currentLotInProcess}}</span>
      <b-spinner v-if="loading" variant="dark" class="mr-1 mt-1 float-right" small/>

      <b-modal size="sm"
               id="modal-comercial"
               @ok="squareUpProcess($route.params.id, 'BRECHA COMERCIAL')"
               title="Brecha Comercial">
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-horizontal"
              label-class="font-weight-bold"
              label-cols-sm="8"
              label-cols-lg="8"
              label="Peso promedio recipiente"
              label-for="input-horizontal">
              <b-form-input type="number"
                            v-model="form.box_avg"
                            step="0.01"
                            class="text-right"
                            autocomplete="off" id="input-horizontal"/>
            </b-form-group>
            <p>Brecha total calculada : {{commercialDiff}}</p>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal id="modal-merma"
               @ok="squareUpProcess($route.params.id, modal_title)"
               :title="modal_title">
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="6"
              label-cols-lg="6"
              label="Recipiente"
              label-for="input-horizontal">
              <search-select v-model="$v.form.container.$model" :submitStatus="submitActive" :validation="$v.form.container"  url="/bagno/container/select_container/"/>
              <b-form-text v-if="form.container.text" class="ml-2">Actualmente seleccionado: <b class="font-size-3">{{form.container.text}}</b></b-form-text>
            </b-form-group>
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="6"
              label-cols-lg="6"
              label="Cantidad"
              label-for="input-horizontal">
              <b-form-input type="text"
                            v-model="$v.form.quantity.$model"
                            :state="$v.form.quantity.$dirty ? !$v.form.quantity.$error : null"
                            @focus="form.quantity=null"
                            step=1
                            v-on:keyup = "inputSoloNumero"
                            autocomplete="off" id="input-horizontal"/>
            </b-form-group>
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="6"
              label-cols-lg="6"
              label="Peso pallet"
              label-for="input-horizontal">
              <b-form-input type="text"
                            v-model="$v.form.pallet_weight.$model"
                            :state="$v.form.pallet_weight.$dirty ? !$v.form.pallet_weight.$error : null"
                            step="0.01"
                            @focus="form.pallet_weight=null"
                            v-on:keyup = "inputSoloNumeroDecimal"
                            autocomplete="off" id="input-horizontal"/>
            </b-form-group>
            <b-form-group
              id="fieldset-horizontal"
              label-cols-sm="6"
              label-cols-lg="6"
              label-for="input-horizontal">
              <template slot="label">
                Peso bruto <a href="#" v-if="materialWeightSum>0" @click.prevent="squareGross">Cuadrar c/ diferencia</a>
              </template>
              <b-form-input type="text"
                            v-model="$v.form.gross_weight.$model"
                            :state="$v.form.gross_weight.$dirty ? !$v.form.gross_weight.$error : null"
                            @focus="form.gross_weight=null"
                            v-on:keyup = "inputSoloNumeroDecimal"
                            step="0.01"
                            autocomplete="off" id="input-horizontal"/>
            </b-form-group>
            <b-form-group
              id="fieldset-horizontal"
              label="Peso Neto"
              label-cols-sm="6"
              label-cols-lg="6"
              label-for="input-horizontal">
              <b-form-input type="number"
                            disabled
                            :value="netWeight"
                            id="input-horizontal"/>
            </b-form-group>
          </b-col>
        </b-row>
         <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="primary"
                    @click.prevent="(e) => {e.target.blur();squareUpProcess($route.params.id, modal_title)}"
                    class="float-right ml-1">Guardar<!-- /imprimir -->
            <b-spinner v-if="loading" class="float-right" small/>
          </b-button>
          <!-- <b-button class="float-right ml-1" variant="primary">Guardar</b-button> -->
          <b-button class="float-right ml-1"  @click="$bvModal.hide('modal-merma')">Cancelar</b-button>
        </div>
      </template>
      </b-modal>


    </span>


</template>

<script>

  import {mapGetters} from 'vuex';
  import searchSelect from '../../searchSelect'
  import {decimal, integer, required, requiredIf} from 'vuelidate/lib/validators'

  export default {
    name: "ProcessInfo",
    components: {
      searchSelect
    },
    data() {
      return {
        loading: false,
        modal_title: "",
        form: {
          pallet_weight: 0,
          gross_weight: 0,
          quantity: 0,
          box_avg: 0,
          container: {
          text: null,
          material_weight: 0
        }
        },
        submitActive: false
      }
    },
    computed: {
      ...mapGetters('bagnoProcessModule', [
        'totalInNet',
        'totalInGross',
        'totalOutNet',
        'totalOutGross',
        'differenceNet',
        'currentLotInProcess',
        'currentProductsInProcess',
        'checkBrechaComercial',
        'totalSaleable',
        'totalQuantitySaleable',
        'totalWaste',
        'getFruitInProcess',
      ]),
      commercialDiff(){
        return this.difference(this.form.box_avg * this.totalQuantitySaleable, this.totalSaleable);
      },
      netWeight() {
        return (this.form.gross_weight - this.form.pallet_weight -
          (this.form.quantity * this.form.container.material_weight)).toFixed(2)
      },
      materialWeightSum() {
        return this.form.container.material_weight * this.form.quantity + this.form.pallet_weight;
      }
    },
    methods: {
      percentage(a, b) {
        return (a / b * 100).toFixed(2)
      },
      difference(a, b) {
        return (a - b).toFixed(2)
      },
      squareGross () {
        this.form.gross_weight = parseFloat(this.differenceNet) + this.materialWeightSum;
      },
      resetForm() {
        this.form.quantity = 0;
        this.form.pallet_weight = 0;
        this.form.gross_weight = 0;

        /* this.form.container= {
          text: null,
          material_weight: 0
        } */

      },
      async squareUpProcess(evt,type) {

        const thisV = this;
        thisV.loading = true;
        let data;
        if (type === 'BRECHA OPERACIONAL') {
          data = {
              'net_kilograms': Math.abs(thisV.difference(thisV.totalOutNet, thisV.totalInNet)),
              'gross_kilograms': Math.abs(thisV.difference(thisV.totalOutGross, thisV.totalInGross)),
              'process': thisV.$route.params.id,
              // The container is harcoded with the name "-", means that the database needs to have a - name container object.
              'container': '-',
              'lot': thisV.currentLotInProcess,
              'fruit_id': thisV.getFruitInProcess,
              'quantity': 0,
              'waste_type': type,
            };

              
          try {
            const response = await thisV.$axios({
              method: "POST",
              url: `bagno/process/${evt}/square_up_process/`,
              data: data
            });
            thisV.$store.dispatch('bagnoProcessModule/addRowsOut', response.data);
            thisV.$toast.success(`Contenido creado con éxito`, "");
            thisV.loading = false;
          } catch (error) {
            console.log(error);
            thisV.$toast.error("Problemas al crear", "");
            thisV.loading = false;
          }

        } else if (type === 'BRECHA COMERCIAL') {

          data = {
              'net_kilograms': thisV.commercialDiff,
              'gross_kilograms': 0,
              'process': thisV.$route.params.id,
            // The container is harcoded with the name "-", means that the database needs to have a - name container object.
              'container': '-',
              'quantity': 0,
              'lot': thisV.currentLotInProcess,
              'fruit_id': thisV.getFruitInProcess,
              'waste_type': type,
            };

          try {
            const response = await thisV.$axios({
              method: "POST",
              url: `bagno/process/${evt}/square_up_process/`,
              data: data
            });
            thisV.$store.dispatch('bagnoProcessModule/addRowsOut', response.data);
            thisV.$toast.success(`Contenido creado con éxito`, "");
            thisV.loading = false;
          } catch (error) {
            console.log(error);
            thisV.$toast.error("Problemas al crear", "");
            thisV.loading = false;
          }

        } else {
          
            this.$v.form.$touch();
            this.submitActive=true;
            if (this.$v.$invalid == true) {
              this.$toast.info("Campos restantes en el formulario", "");
              thisV.loading = false;
            } else {
       
              if (this.netWeight >= 0) {
             
                  data = {
                  'net_kilograms': thisV.netWeight,
                  'gross_kilograms': thisV.form.gross_weight,
                  'container': thisV.form.container.text,
                  'process': thisV.$route.params.id,
                  'quantity': thisV.form.quantity,
                  'lot': thisV.currentLotInProcess,
                  'fruit_id': thisV.getFruitInProcess,
                  'waste_type': type,
                };

        if(parseFloat(thisV.netWeight) > parseFloat(this.differenceNet))
        {

          thisV.$toast.info("kilos ingresados superan el total de kilos volteados", "");
          thisV.loading = false;
          thisV.submitStatus=false;

        }else{

          try {
                const response = await thisV.$axios({
                  method: "POST",
                  url: `bagno/process/${evt}/square_up_process/`,
                  data: data
                });

                thisV.$bvModal.hide("modal-merma");
                thisV.resetForm();
                thisV.$store.dispatch('bagnoProcessModule/addRowsOut', response.data);
                thisV.$toast.success(`Contenido creado con éxito`, "");
                thisV.loading = false;
                thisV.submitActive=false;

              } catch (error) {
                console.log(error);
                thisV.$bvModal.hide("modal-merma");
                thisV.resetForm();
                thisV.$toast.error("Problemas al crear", "");
                thisV.loading = false;
                thisV.submitActive=false;
              }

        }

          }else{
            thisV.loading = false;
            this.$toast.info("El campo peso neto no puede ser negativo", "");
          }


           }

        }
       
      },
       inputSoloNumero(event) {
     event.target.value = event.target.value.replace(/[^0-9]/, '');
    },
    inputSoloNumeroDecimal(event) {
     event.target.value = event.target.value.replace(/[^0-9.]/, '');
    }
      
    },
    validations: {
      form: {
        container: {
            text: {required},
            material_weight: {required},
          },
        quantity:{required,integer},
        pallet_weight:{required},
        gross_weight:{required},
      }
    },
  }
</script>

<style scoped>

</style>
